<!--
 @description view数据源选择页
 @author huangzhijie
 @date 2018/11/1
-->
<template>
  <div>
    <back :history="history"></back>
    <source-group 
      @data-source-skip="skipTo" 
      :is-delete="false" 
      :is-add="false">
    </source-group>
  </div>
</template>
<script>
import back from '@/components/back.vue'
import sourceGroup from '@/views/component/sourceGroup'
export default {
  components: {
    back,
    sourceGroup
  },
  data () {
    return {
      title: '',
      history: []
    }
  },
  methods: {
    setHistory () {
      this.history = []
      const historyMap = {
        'Area': this.$t('view.chartArea'),
        'Line': this.$t('view.chartLine'),
        'Histogram': this.$t('view.chartHistogram'),
        'Pie': this.$t('view.chartPie'),
        'Table': this.$t('view.tableTable')
      }
      this.history.push(
        { name: this.$t('view.config') },
        {
          name: `${this.$t('view.selectChart')}（${historyMap[this.$route.query.type]}）`,
          path: '/home/view/viewChartSelect'
        }
      )
      this.history.push({ name: this.$t('view.selectDataSource') })
    },
    init () {
      this.setHistory()
    },
    skipTo (item) {
      const chooseType = this.$route.query.type
      let queryObj = {
        type: chooseType,
        group: item.group,
        dId: item.id
      }
      if (item.group === 'others') {
        queryObj.dName = item.name
      } else {
        queryObj.appName = item.appName
        queryObj.kpiKey = item.kpiKey
        queryObj.dName = item.desc
        queryObj.siteCode = item.siteCode
      }
      this.$router.push({
        name: 'viewConfig',
        query: queryObj
      })
    }
  },
  mounted () {
  },
  activated () {
    this.init()
  }
}
</script>